import { fmtPrice, useT } from '@repo/common';

const RefundItemRow = ({ item, currency }) => {
  const t = useT();

  return (
  <div className='flex items-start gap-4 py-4 border-b border-grayscale-gray02 w-full'>
    <img
      src={item.thumbnailUrl}
      alt=''
      className='h-[80px] w-[80px] shrink-0 rounded-lg object-cover bg-grayscale-gray02'
    />
    <div className='flex flex-col gap-2 w-full'>
      <div className='flex min-w-0 flex-col items-start justify-center gap-2 w-full'>
        <div className='flex flex-col gap-0.5 w-full'>
          <span className='typo-b14Strong text-text-primary truncate'>
            {item.workshopName}
          </span>
          <span className='typo-b12Strong text-text-primary'>
            {item.dateLabel}
          </span>
          <span className='typo-b12 text-text-placeholder'>
            {t('Payment method:', '결제 수단:')} {item.paymentMethod}
          </span>
        </div>
      </div>
      <div className='flex items-center justify-end gap-2'>
        <span className='typo-b14 text-text-placeholder'>
          {t('Original price:', '정가:')}
        </span>
        <span className='typo-b14Strong text-text-primary'>
          {fmtPrice(item.originalPrice, currency)}
        </span>
      </div>
    </div>
  </div>
  );
};

const RefundItemList = ({ items, currency }) => (
  <div>
    {items.map((item) => (
      <RefundItemRow key={item.bookingId} item={item} currency={currency} />
    ))}
  </div>
);

export default RefundItemList;
